/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cancelOutboundPhone} from '../api'

export const useMutationCancelOutboundPhone = createReactQueryMutationHook('cancelOutboundPhone', cancelOutboundPhone)
